import styled from 'styled-components';

import Image from '../Image/Image';

import { CssClassName } from '../../../utils/generateCssClassName/types';

export const IconWrapper = styled.div`
  width: auto;
  height: 26px;
  margin: 0 1.5rem 0 0;

  &.${CssClassName.KIOSK} {
    display: none;
  }
`;

export const IconImage = styled(Image)`
  width: auto;
  height: 100%;
`;
